import { Row, Col, Card } from 'react-bootstrap';

const ThankYouPage = () => {
  return (
    <>
      <h1 className="mt-4 text-center justify-content-center w-100">
        Your Submission has been received
      </h1>
      <Row className="mt-5 justify-content-center">
        <Col md={8} style={{ maxWidth: 600 }}>
          <Card className="p-3">
            <p>Thank you for submitting your Auditor Tip</p>
            <p>You should receive a confirmation email shortly</p>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ThankYouPage;
